import "./vendor/bootstrap";
import "./modules/sticky-ad";
import "./modules/responsive-menu";
import "./modules/menu";
import "./modules/inline-share-buttons";
import { doForminatorMessageFix } from "./modules/forminator-fix";


function handleContentMutationEvent() {
  document.dispatchEvent(new CustomEvent('content-added'));
}

document.addEventListener('DOMContentLoaded', () => {
  doForminatorMessageFix();

  const target = document.querySelector('.content_wrapper');

  if (target instanceof HTMLDivElement) {
    // Observe mutations on .content_wrapper
    // Used for infinite scroll
    const observer = new MutationObserver(handleContentMutationEvent);

    observer.observe(target, {
      childList: true,
    });
  }
});